import { mittausCacheGet } from '../../../utils/mittausCache';

const TH = { font: 'Lato', fontSize: 8, bold: true, color: '#fff', fillColor: '#04aa00', alignment: 'center' };

function fmtNum(v, d = 2) {
  if (v === null || v === undefined || v === '') return '—';
  const n = parseFloat(v);
  return isNaN(n) ? '—' : n.toFixed(d);
}

function fmtDepth(row) {
  const f = row.murtosyvyysFrom;
  const t = row.murtosyvyysTo;
  const type = row.murtosyvyysType ?? 'up';
  if (!f && !t) return '—';
  if (!t) return `${type} ${f}`;
  return `${type} ${f} – ${t}`;
}

function blockCaption(blockData, projekt) {
  const raw = blockData?.caption;
  if (!raw) return projekt?.nimi ?? '';
  return (typeof raw === 'string' ? raw : raw.value ?? '').trim() || (projekt?.nimi ?? '');
}

export function renderVetolujuusBlock({ block, content, rakennusData, tableCounter }) {
  const blockData = block?.data ?? {};
  const projekt = blockData.mittausProjektiId ? mittausCacheGet(blockData.mittausProjektiId) : null;
  const kohteet = (projekt?.kohteet ?? []).filter(k => (k.data ?? []).length > 0);
  if (!kohteet.length) return;

  const headerRow = [
    { text: 'Tunnus',             ...TH },
    { text: 'Ø mm',               ...TH },
    { text: 'Vetolujuus\nMN/m²',  ...TH },
    { text: 'Murtosyvyys\nmm',    ...TH },
    { text: 'Murtotapa',          ...TH },
    { text: 'Lisähuomiot',        ...TH },
  ];

  const TD = (text) => ({ text, font: 'Lato', fontSize: 8, alignment: 'center' });
  const layout = {
    hLineWidth: () => 0.5, vLineWidth: () => 0.5,
    hLineColor: () => '#adb5bd', vLineColor: () => '#adb5bd',
    paddingLeft: () => 3, paddingRight: () => 3,
    paddingTop: () => 3, paddingBottom: () => 3,
    fillColor: (row) => row === 0 ? '#04aa00' : (row % 2 === 0 ? '#f8f9fa' : null),
  };

  const allRows = kohteet.flatMap(k => Array.isArray(k.data) ? k.data : []);
  if (!allRows.length) return;

  const tblNum = tableCounter ? ++tableCounter.value : null;
  const bodyRows = allRows.map(row => [
    TD(row.tunnus || '—'),
    TD(row.diameter ? String(row.diameter) : '—'),
    TD(fmtNum(row.vetolujuus)),
    TD(fmtDepth(row)),
    TD(row.murtotapa || '—'),
    TD(row.lisahuomiot || ''),
  ]);

  content.push({
    stack: [
      { table: { headerRows: 1, widths: [42, 28, 46, 54, '*', '*'], body: [headerRow, ...bodyRows] }, layout, margin: [0, 5, 0, 0] },
      ...(tblNum !== null ? [{
        text: [{ text: `Taulukko ${tblNum}. `, bold: true }, { text: blockCaption(blockData, projekt), bold: false }],
        font: 'Lato', fontSize: 9,
        margin: [0, 4, 0, 0],
      }] : []),
    ],
    margin: [0, 0, 0, 15],
  });
}
